/* Skapad av Claude Code — filterknapparna i SVD Kollektion intro (SEO 2. Filter).
   Klick lägger till/tar bort taggen i adressen (filter.p.tag, flera = OCH). Rutnät + knapprad hämtas i
   ETT anrop (Section Rendering, sections=rutnät,intro) och läggs in med temats egna FacetFiltersForm-
   funktioner (rutnät, filterlåda, antal, adress + bakåtknapp) — ingen omladdning.
   Mjukt: hämtningen startar redan vid pointerdown, knappen markeras direkt, svar cachas, sena svar
   kastas, och knappraden PATCHAS (bara antal/markeringar ändras) så scrollposition och bredder står still.
   Utan temats filterskript: vanlig länk (sidan laddas om). */
(function () {
  if (window.svdCollFilter) return;
  window.svdCollFilter = true;
  var TAG = 'filter.p.tag', cache = {}, senaste = 0;
  function rad() { return document.querySelector('.svd-coll-filter'); }
  function sektionsId(el) { var s = el && el.closest('.shopify-section'); return s ? s.id.replace('shopify-section-', '') : null; }
  function rutnatId() { var g = document.getElementById('product-grid'); return g ? g.getAttribute('data-id') : null; }
  function valda(qs) { return new URLSearchParams(qs).getAll(TAG).map(function (t) { return t.toLowerCase(); }); }
  function qsFor(a) {
    var sp = new URLSearchParams(location.search), t = sp.getAll(TAG);
    sp.delete(TAG); sp.delete('page');
    if (!a.hasAttribute('data-alla')) {
      var x = a.getAttribute('data-tagg'), i = -1;
      t.forEach(function (s, n) { if (s.toLowerCase() === x.toLowerCase()) i = n; });
      if (i > -1) t.splice(i, 1); else t.push(x);
      t.forEach(function (s) { sp.append(TAG, s); });
    }
    return sp.toString();
  }
  function hamta(qs) {
    if (!cache[qs]) {
      var ids = [rutnatId(), sektionsId(rad())].filter(Boolean).join(',');
      cache[qs] = fetch(location.pathname + '?sections=' + encodeURIComponent(ids) + (qs ? '&' + qs : ''))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete cache[qs]; throw e; });
    }
    return cache[qs];
  }
  function markera(qs) {
    var n = rad(); if (!n) return;
    var v = valda(qs);
    n.querySelectorAll('a[data-tagg]').forEach(function (a) {
      if (v.indexOf(a.getAttribute('data-tagg').toLowerCase()) > -1) { a.setAttribute('aria-current', 'true'); a.removeAttribute('aria-disabled'); }
      else a.removeAttribute('aria-current');
    });
    var alla = n.querySelector('a[data-alla]');
    if (alla) { if (v.length) alla.removeAttribute('aria-current'); else alla.setAttribute('aria-current', 'true'); }
  }
  function patchaRad(html) {
    var ny = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.svd-coll-filter');
    var nu = rad(); if (!ny || !nu) return;
    ny.querySelectorAll('a.svd-coll-chip').forEach(function (a) {
      var m = a.hasAttribute('data-alla') ? nu.querySelector('a[data-alla]')
        : Array.prototype.find.call(nu.querySelectorAll('a[data-tagg]'), function (x) { return x.getAttribute('data-tagg') === a.getAttribute('data-tagg'); });
      if (!m) return;
      if (m.getAttribute('href') !== a.getAttribute('href')) m.setAttribute('href', a.getAttribute('href'));
      ['aria-current', 'aria-disabled'].forEach(function (k) { if (a.hasAttribute(k)) m.setAttribute(k, a.getAttribute(k)); else m.removeAttribute(k); });
      var x = a.querySelector('.svd-coll-chip__antal'), y = m.querySelector('.svd-coll-chip__antal');
      if (x && y && y.textContent !== x.textContent) y.textContent = x.textContent;
    });
  }
  function tillampa(qs, json, push) {
    var g = rutnatId(), i = sektionsId(rad());
    if (g && json[g]) {
      try {
        FacetFiltersForm.renderFilters(json[g], null);
        FacetFiltersForm.renderProductGridContainer(json[g]);
        FacetFiltersForm.renderProductCount(json[g]);
        if (typeof FacetsToggle !== 'undefined') new FacetsToggle();
      } catch (e) { location.href = location.pathname + (qs ? '?' + qs : ''); return; }
      FacetFiltersForm.searchParamsPrev = qs;
      if (push) FacetFiltersForm.updateURLHash(qs);
    }
    if (i && json[i]) patchaRad(json[i]);
    markera(qs);
    var n = rad(); if (n) n.removeAttribute('aria-busy');
  }
  function laddar(pa) {
    var c = document.getElementById('ProductGridContainer'), k = c && c.querySelector('.collection');
    if (k) k.classList.toggle('loading', pa);
    var n = rad(); if (n) { if (pa) n.setAttribute('aria-busy', 'true'); else n.removeAttribute('aria-busy'); }
  }
  function knapp(e) { var a = e.target.closest && e.target.closest('.svd-coll-filter a'); return a && a.getAttribute('aria-disabled') !== 'true' ? a : null; }
  document.addEventListener('pointerdown', function (e) { var a = knapp(e); if (a && typeof FacetFiltersForm !== 'undefined') hamta(qsFor(a)).catch(function () {}); }, { passive: true });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.svd-coll-filter a');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    if (a.getAttribute('aria-disabled') === 'true') return;
    var qs = qsFor(a);
    if (typeof FacetFiltersForm === 'undefined' || !document.getElementById('ProductGridContainer')) { location.href = location.pathname + (qs ? '?' + qs : ''); return; }
    var nr = ++senaste;
    markera(qs);
    laddar(true);
    hamta(qs).then(function (json) { if (nr === senaste) tillampa(qs, json, true); })
      .catch(function () { if (nr === senaste) location.href = location.pathname + (qs ? '?' + qs : ''); });
  });
  window.addEventListener('popstate', function () {
    var qs = location.search.slice(1), nr = ++senaste;
    markera(qs);
    hamta(qs).then(function (json) { if (nr !== senaste) return; var i = sektionsId(rad()); if (i && json[i]) patchaRad(json[i]); markera(qs); laddar(false); }).catch(function () {});
  });
  markera(location.search.slice(1));
})();
